import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../../api';
import { Spinner, Alert, EmptyState, Badge } from '../../components/UI';

function ringColor(pct) {
  if (pct >= 75) return 'var(--success)';
  if (pct >= 50) return 'var(--warning)';
  return 'var(--danger)';
}

function formatDate(ts) {
  if (!ts) return '-';
  return new Date(ts).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
}

export default function MyResults() {
  const [results, setResults] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    api.get('/exam/my-results').then(setResults).catch(e => setError(e.message));
  }, []);

  if (!results && !error) return <Spinner />;

  const list = results || [];
  const publishedCount = list.filter(r => r.is_published).length;
  const pendingCount = list.length - publishedCount;

  return (
    <div className="content-narrow">
      <div className="page-header">
        <div>
          <div className="eyebrow">History</div>
          <h1>My results</h1>
        </div>
      </div>

      <Alert type="danger">{error}</Alert>

      {list.length === 0 && !error && (
        <div className="card">
          <EmptyState title="No results yet" sub="Once you submit an exam and it's published by the admin, it will show up here." />
        </div>
      )}

      {list.length > 0 && (
        <>
          <div className="results-summary">
            <div className="rs-item"><span className="rs-num">{list.length}</span><span className="rs-label">Exams taken</span></div>
            <div className="rs-item"><span className="rs-num">{publishedCount}</span><span className="rs-label">Published</span></div>
            <div className="rs-item"><span className="rs-num">{pendingCount}</span><span className="rs-label">Awaiting result</span></div>
          </div>

          <div className="result-list">
            {list.map(r => {
              const pct = r.is_published && r.max_score > 0
                ? Math.round((r.total_score / r.max_score) * 100)
                : null;
              return (
                <div className="result-card" key={r.id}>
                  <div className="result-info">
                    <div className="result-title">{r.paper_title}</div>
                    <div className="result-meta">Submitted {formatDate(r.submitted_at)}</div>
                  </div>

                  {r.is_published ? (
                    <div className="result-score">
                      <div className="score-side">
                        <div className="score-fraction">{r.total_score} / {r.max_score}</div>
                        <Link to={`/my-results/${r.id}`} className="btn btn-outline btn-sm">View details</Link>
                      </div>
                      <div className="score-ring" style={{ '--pct': pct, '--ring': ringColor(pct) }}>
                        <span>{pct}%</span>
                      </div>
                    </div>
                  ) : (
                    <div className="result-pending">
                      <Badge tone="warning">Awaiting result</Badge>
                      <div className="result-meta">Your score appears once the admin publishes it.</div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
}
